export const PHOTO_BUCKET = 'ds-webassets'
export const S3_HOST_PATH = 'https://s3.amazonaws.com'

export const RENT_COMPS_PAGE_TITLE = 'COMPARABLE RENTAL PROPERTIES'
export const SALES_COMPS_PAGE_TITLE = 'COMPARABLE SALE PROPERTIES'
export const RENT_COMPARABLES = 'rentComps'
export const SALES_COMPARABLES = 'salesComps'
export const SH_COMPARABLES = 'studentHousingComps'

export const compsMappingData = {
  summaryData: [
    { key: 'name', value: 'Property Name' },
    { key: 'city', value: 'City' },
    { key: 'propertyAddress', value: 'Distance' },
    { key: 'units', value: 'Units' },
    { key: 'yearBuilt', value: 'Built' },
    { key: 'yearRen', value: 'Renovated' },
    { key: 'occupancyAsOfDate', value: 'Occupancy' },
    { key: 'rentableSf', value: 'RSF' },
    { key: 'avgSf', value: 'Avg SF' },
    { key: 'avgMarketRentSf', value: 'Avg Market Rent', fallbackValue: 'Avg Market  Rent' },
    { key: 'avgRentSf', value: 'Avg Rent/SF' },
    { key: 'date', value: 'Updated' },
    { key: 'notes', value: 'Notes' },
    { key: 'propertySFId', value: 'Property SF ID' },
    { key: 'propertyType', value: 'propertyType' },
    { key: 'mostRecentSaleDate', value: 'Sale Date' },
    { key: 'mostRecentSalePrice', value: 'Sale Price' },
    { key: 'priceUnit', value: 'Price/Unit' },
    { key: 'priceSf', value: 'Price/SF' },
    { key: 'sfSellerAccountId', value: 'Seller' },
    { key: 'sfBuyerAccountId', value: 'Buyer' },
    { key: 'capRate', value: 'CAP' },
    { key: 'grossRentMultiplier', value: 'GRM' },
    { key: 'termsOfSale', value: 'Terms' },
    { key: 'state', value: 'State' },
    { key: 'beds', value: '# Beds' },
    { key: 'mrPerBed', value: 'MR/Bed' },
    { key: 'erPerBed', value: 'ER/Bed' },
    { key: 'propertyAddressLatitude', value: 'propertyAddressLatitude' },
    { key: 'propertyAddressLongitude', value: 'propertyAddressLongitude' }
  ],
  propertyData: [
    { key: 'propertyType', value: 'propertyType' },
    { key: 'name', value: 'Property Name' },
    { key: 'city', value: 'City' },
    { key: 'addressLine1', value: 'Address' },
    { key: 'units', value: 'Units' },
    { key: 'county', value: 'County' },
    { key: 'state', value: 'State' },
    { key: 'zipCode', value: 'Zip' },
    { key: 'propertyAddress', value: 'Distance' },
    { key: 'yearBuilt', value: 'Built' },
    { key: 'yearRen', value: 'Renovated' },
    { key: 'type', value: 'Type' },
    { key: 'imageUrl', value: 'imageUrl' },
    { key: 'subType', value: 'Subtype' },
    { key: 'metering', value: 'Metering' },
    { key: 'occupancyAsOfDate', value: 'Occupancy' },
    { key: 'rentComments', value: 'Rent Comments' },
    { key: 'amenities', value: 'Amenities' },
    { key: 'amenitiesWriteins', value: 'Amenities (write ins)' },
    { key: 'sourceNote', value: 'Source Notes' },
    { key: 'notes', value: 'Notes' },
    { key: 'mostRecentSaleDate', value: 'Sale Date' },
    { key: 'mostRecentSalePrice', value: 'Price' },
    { key: 'priceUnit', value: 'Price/Unit' },
    { key: 'priceSf', value: 'Price/SF' },
    { key: 'sfSellerAccountId', value: 'Seller' },
    { key: 'sfBuyerAccountId', value: 'Buyer' },
    { key: 'capRate', value: 'CAP' },
    { key: 'grossRentMultiplier', value: 'GRM' },
    { key: 'averageRentUnit', value: 'Avg. Rent/Unit' },
    { key: 'averageRentSf', value: 'Avg. Rent/SF' },
    { key: 'rentableSf', value: 'RSF' },
    { key: 'averageSf', value: 'averageSf' },
    { key: 'avgRentSf', value: 'avgRentSf' },
    { key: 'avgMarketRentSf', value: 'avgMarketRentSf' },
    { key: 'beds', value: '# BEDS' }
  ],
  comparableData: [
    { key: 'date', value: 'DATE' },
    { key: 'source', value: 'SOURCE' },
    { key: 'unitType', value: 'UNIT TYPE' },
    { key: 'units', value: '#UNITS' },
    { key: 'unitSize', value: 'UNIT SIZE' },
    { key: 'totalSize', value: 'TOTAL SIZE' },
    { key: 'unitMarketRent', value: 'UMR' },
    { key: 'unitEffectiveRent', value: 'UER' },
    { key: 'mrPerSf', value: 'MR/SF' },
    { key: 'erPerSf', value: 'ER/SF' },
    { key: 'totalMr', value: 'TOTAL MR' },
    { key: 'totalEr', value: 'TOTAL ER' },
    { key: 'comments', value: 'COMMENTS' },
    { key: 'bedsPerunit', value: 'BEDS/UNIT' },
    { key: 'beds', value: '# BEDS' },
    { key: 'mrPerBed', value: 'MR/BED' },
    { key: 'erPerBed', value: 'ER/BED' },
    { key: 'omniViewPropertyRentId', value: 'Rent ID' }
  ]
}

export const numericFields = [
  'avgMarketRentSf', 'avgRentSf', 'avgSf', 'grossRentMultiplier', 'occupancyAsOfDate', 'rentableSf', 'propertyAddress',
  'capRate', 'mostRecentSalePrice', 'priceSf', 'priceUnit', 'units', 'yearBuilt', 'yearRen', 'mrPerBed', 'erPerBed', 'beds'
]

export const comparableNumericFields = [
  'erPerSf', 'mrPerSf', 'totalEr', 'totalMr', 'totalSize',
  'unitEffectiveRent', 'unitMarketRent', 'unitSize', 'units', 'mrPerBed', 'erPerBed', 'beds', 'occupancyAsOfDate'
]

export const propertyDataNumericFields = [
  'averageRentSf', 'averageRentUnit', 'grossRentMultiplier', 'mostRecentSalePrice',
  'occupancyAsOfDate', 'priceSf', 'priceUnit', 'units', 'yearBuilt', 'yearRen', 'capRate', 'rentableSf', 'averageSf', 'avgMarketRentSf', 'avgRentSf'
]

export const Toggle_Access_List = {
  toggeleNotes: ['T1', 'T2', 'T3', 'SH1'],
  toggleSourceNotes: ['T1', 'T2', 'T3', 'S1', 'SH1'],
  toggleUnitMix: ['S1'],
  toggleAmenities: ['T1', 'T2', 'T4', 'SH1'],
  toggleDonutChart: ['T1', 'T2', 'T3', 'T4', 'T5', 'SH1']
}

// PROPERTY FIELDS
export const SUMMARY_TABLE_COLUMNS_RENT = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Avg SF', value: 'avgSf' },
  { key: 'Avg Rent', value: 'avgMarketRentSf' },
  { key: 'Avg Rent/SF', value: 'avgRentSf' },
  { key: 'NA', value: 'NA' }
]

export const SUMMARY_TABLE_COLUMNS_RENT_T6 = [
  { key: 'Property Name', value: 'name' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'RSF', value: 'rentableSf' },
  { key: 'Avg SF', value: 'avgSf' },
  { key: 'Avg Rent', value: 'avgMarketRentSf' },
  { key: 'Avg Rent/SF', value: 'avgRentSf' },
  { key: 'NA', value: 'NA' }
]

export const SUMMARY_TABLE_COLUMNS_SALES = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'Sale Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'NA', value: 'NA' }
]

export const SUMMARY_TABLE_COLUMNS_SALES_S2 = [
  { key: 'Property Name', value: 'name' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'Sale Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'CAP', value: 'capRate' },
  { key: 'NA', value: 'NA' }
]

export const SUMMARY_TABLE_ALL_COLUMNS_RENT = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Avg SF', value: 'avgSf' },
  { key: 'Avg Rent', value: 'avgMarketRentSf' },
  { key: 'Avg Rent/SF', value: 'avgRentSf' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'State', value: 'state' },
  { key: 'Notes', value: 'notes' }
]

export const SUMMARY_TABLE_ALL_COLUMNS_SALES = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'Sale Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'GRM', value: 'grossRentMultiplier' },
  { key: 'CAP', value: 'capRate' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'State', value: 'state' }
]

export const SUMMARY_TABLE_ALL_COLUMNS_SALES2 = [
  { key: 'Property Name', value: 'name' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'Sale Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'GRM', value: 'grossRentMultiplier' },
  { key: 'CAP', value: 'capRate' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'RSF', value: 'rentableSf' },
  { key: 'Buyer', value: 'sfBuyerAccountId' },
  { key: 'Seller', value: 'sfSellerAccountId' }
]

export const SUMMARY_TABLE_COLUMNS_SH = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Beds', value: 'beds' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Avg SF', value: 'avgSf' },
  { key: 'Avg Rent/SF', value: 'avgRentSf' },
  { key: 'Avg Rent/BED', value: 'mrPerBed' },
  { key: 'NA', value: 'NA' }
]

export const SUMMARY_TABLE_ALL_COLUMNS_SH = [
  { key: 'Property Name', value: 'name' },
  { key: 'City', value: 'city' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Beds', value: 'beds' },
  { key: 'Units', value: 'units' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Avg SF', value: 'avgSf' },
  { key: 'Avg Rent/SF', value: 'avgRentSf' },
  { key: 'Avg Rent/BED', value: 'mrPerBed' },
  { key: 'AVG Mkt Rent', value: 'avgMarketRentSf' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'RSF', value: 'rentableSf' },
  { key: 'Notes', value: 'notes' }
]

export const SUMMARY_TABLE_COLUMNS_MANDATORY_RENT = ['name']
export const SUMMARY_TABLE_COLUMNS_MANDATORY_SALES = ['name']
export const SUMMARY_TABLE_COLUMNS_MANDATORY_SH = ['name']

export const rentUnitMixHeader = ['DATE', 'SOURCE', 'UNIT TYPE', '#UNITS', 'UNIT SIZE', 'TOTAL SIZE', 'UMR', 'UER', 'MR/SF', 'ER/SF', 'TOTAL MR', 'TOTAL ER', 'COMMENTS', 'Rent ID']
export const studentHousingUnitMixHeader = ['DATE', 'SOURCE', 'UNIT TYPE', '#UNITS', 'BEDS/UNIT', '# BEDS', 'UNIT SIZE', 'TOTAL SIZE', 'MR/BED', 'ER/BED', 'UMR', 'UER', 'MR/SF', 'ER/SF', 'TOTAL MR', 'TOTAL ER', 'COMMENTS', 'Rent ID']
export const propListHeader = ['Address', 'City', 'County', 'State', 'Zip', 'Distance', 'Built', 'Renovated', 'Type', 'Subtype', 'Metering', 'Occupancy', 'Amenities', 'Rent Comments', 'Amenities (write ins)', 'Source Notes']

export const PROPERTY_FIELDS_RENT = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const PROPERTY_FIELDS_RENT_T5 = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const PROPERTY_FIELDS_SALES = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const PROPERTY_ALL_FIELDS_RENT = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'Type', value: 'type' }
]

export const PROPERTY_ALL_FIELDS_RENT_T5 = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'Type', value: 'type' },
  { key: 'Avg SF', value: 'averageSf' },
  { key: 'Avg Rent SF', value: 'avgRentSf' },
  { key: 'Avg Rent', value: 'avgMarketRentSf' }
]

export const PROPERTY_ALL_FIELDS_SALES = [
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Price', value: 'mostRecentSalePrice' },
  { key: 'Price/Unit', value: 'priceUnit' },
  { key: 'Price/SF', value: 'priceSf' },
  { key: 'Sale Date', value: 'mostRecentSaleDate' },
  { key: 'CAP', value: 'capRate' },
  { key: 'GRM', value: 'grossRentMultiplier' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'Buyer', value: 'sfBuyerAccountId' },
  { key: 'Seller', value: 'sfSellerAccountId' },
  { key: 'Avg SF', value: 'averageSf' },
  { key: 'Rentable SF', value: 'rentableSf' }
]

export const PROPERTY_FIELDS_SH = [
  { key: 'Beds', value: 'beds' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const PROPERTY_ALL_FIELDS_SH = [
  { key: 'Beds', value: 'beds' },
  { key: 'Built', value: 'yearBuilt' },
  { key: 'Units', value: 'units' },
  { key: 'Distance', value: 'propertyAddress' },
  { key: 'Occupancy', value: 'occupancyAsOfDate' },
  { key: 'Renovated', value: 'yearRen' },
  { key: 'Type', value: 'type' }
]

export const PROPERTY_FIELDS_MANDATORY_RENT = []
export const PROPERTY_FIELDS_MANDATORY_SALES = []
export const PROPERTY_FIELDS_MANDATORY_SH = []

export const FLOOR_PLAN_SUMMARY_TABLE_COLUMNS = [
  { key: 'Property Name', value: 'name' },
  { key: 'Units', value: 'units' },
  { key: 'Built / Renovated', value: 'builtPerRenovated' },
  { key: 'Avg Unit Size', value: 'avgUnitSize' },
  { key: 'AVG Mkt Rent', value: 'avgMarketRentSf' },
  { key: 'AVG Rent/SF', value: 'avgRentSf' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const FLOOR_PLAN_SUMMARY_TABLE_COLUMNS_ALL = [
  { key: 'Property Name', value: 'name' },
  { key: 'Units', value: 'units' },
  { key: 'Built / Renovated', value: 'builtPerRenovated' },
  { key: 'Avg Unit Size', value: 'avgUnitSize' },
  { key: 'AVG Mkt Rent', value: 'avgMarketRentSf' },
  { key: 'AVG Rent/SF', value: 'avgRentSf' },
  { key: 'Eff Rent', value: 'unitEffectiveRent' },
  { key: 'Eff Rent/SF', value: 'erPerSf' }
]

export const FLOOR_PLAN_SUMMARY_MANDATORY = ['name']

export const UNITMIX_TABLE_COLUMNS = [
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Market Rent', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'NA', value: 'NA' }
]

export const UNITMIX_TABLE_COLUMNS_ALL = [
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Market Rent', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'Comments', value: 'comments' }
]

export const UNITMIX_TABLE_COLUMNS_MANDATORY = ['units', 'unitType']

export const UNITMIX_TABLE_COLUMNS_T1 = [
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Market Rent', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'NA', value: 'NA' },
  { key: 'NA', value: 'NA' }
]

export const UNITMIX_TABLE_COLUMNS_ALL_T1 = [
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Market Rent', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'Eff Rent', value: 'unitEffectiveRent' },
  { key: 'Eff Rent/SF', value: 'erPerSf' },
  { key: 'Comments', value: 'comments' }
]

export const UNITMIX_TABLE_COLUMNS_SH1 = [
  { key: 'Beds', value: 'beds' },
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Rent/Bed', value: 'erPerBed' },
  { key: 'Rent/Unit', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'NA', value: 'NA' }
]

export const UNITMIX_TABLE_COLUMNS_SH1_ALL = [
  { key: 'Beds', value: 'beds' },
  { key: 'Units', value: 'units' },
  { key: 'Unit Type', value: 'unitType' },
  { key: 'Unit SF', value: 'unitSize' },
  { key: 'Rent/Bed', value: 'erPerBed' },
  { key: 'Rent/Unit', value: 'unitMarketRent' },
  { key: 'Rent/SF', value: 'mrPerSf' },
  { key: 'Eff Rent', value: 'unitEffectiveRent' },
  { key: 'Eff Rent/SF', value: 'erPerSf' },
  { key: 'Comments', value: 'comments' }
]

export const UNITMIX_TABLE_COLUMNS_SH1_MANDATORY = ['beds', 'units', 'unitType']

export const propertyFieldsRent = {
  propertyFields: [...PROPERTY_FIELDS_RENT],
  mandatoryFields: [...PROPERTY_FIELDS_MANDATORY_RENT],
  allFields: [...PROPERTY_ALL_FIELDS_RENT]
}

export const propertyFieldsRentT5 = {
  propertyFields: [...PROPERTY_FIELDS_RENT_T5],
  mandatoryFields: [...PROPERTY_FIELDS_MANDATORY_RENT],
  allFields: [...PROPERTY_ALL_FIELDS_RENT_T5]
}

export const propertyFieldsSales = {
  propertyFields: [...PROPERTY_FIELDS_SALES],
  mandatoryFields: [...PROPERTY_FIELDS_MANDATORY_SALES],
  allFields: [...PROPERTY_ALL_FIELDS_SALES]
}

export const propertySummaryRent = {
  propertyFields: [...SUMMARY_TABLE_COLUMNS_RENT],
  mandatoryFields: [...SUMMARY_TABLE_COLUMNS_MANDATORY_RENT],
  allFields: [...SUMMARY_TABLE_ALL_COLUMNS_RENT]
}

export const propertySummaryRentT6 = {
  propertyFields: [...SUMMARY_TABLE_COLUMNS_RENT],
  mandatoryFields: [...SUMMARY_TABLE_COLUMNS_MANDATORY_RENT],
  allFields: SUMMARY_TABLE_ALL_COLUMNS_RENT.filter(obj => obj.value !== 'city')
}

export const propertySummarySales = {
  propertyFields: [...SUMMARY_TABLE_COLUMNS_SALES],
  mandatoryFields: [...SUMMARY_TABLE_COLUMNS_MANDATORY_SALES],
  allFields: [...SUMMARY_TABLE_ALL_COLUMNS_SALES]
}

export const propertySummarySales2 = {
  propertyFields: [...SUMMARY_TABLE_COLUMNS_SALES_S2],
  mandatoryFields: [...SUMMARY_TABLE_COLUMNS_MANDATORY_SALES],
  allFields: [...SUMMARY_TABLE_ALL_COLUMNS_SALES2]
}

export const floorPlanSummary = {
  propertyFields: [...FLOOR_PLAN_SUMMARY_TABLE_COLUMNS],
  mandatoryFields: [...FLOOR_PLAN_SUMMARY_MANDATORY],
  allFields: [...FLOOR_PLAN_SUMMARY_TABLE_COLUMNS_ALL]
}

export const propertyFieldsStudentHousing = {
  propertyFields: [...PROPERTY_FIELDS_SH],
  mandatoryFields: [...PROPERTY_FIELDS_MANDATORY_SH],
  allFields: [...PROPERTY_ALL_FIELDS_SH]
}

export const propertySummaryStudentHousing = {
  propertyFields: [...SUMMARY_TABLE_COLUMNS_SH],
  mandatoryFields: [...SUMMARY_TABLE_COLUMNS_MANDATORY_SH],
  allFields: [...SUMMARY_TABLE_ALL_COLUMNS_SH]
}

export const unitmixSummaryRent = {
  propertyFields: [...UNITMIX_TABLE_COLUMNS],
  mandatoryFields: [...UNITMIX_TABLE_COLUMNS_MANDATORY],
  allFields: [...UNITMIX_TABLE_COLUMNS_ALL]
}

export const unitmixSummaryRentT1 = {
  propertyFields: [...UNITMIX_TABLE_COLUMNS_T1],
  mandatoryFields: [...UNITMIX_TABLE_COLUMNS_MANDATORY],
  allFields: [...UNITMIX_TABLE_COLUMNS_ALL_T1]
}

export const unitmixSummaryRentSH1 = {
  propertyFields: [...UNITMIX_TABLE_COLUMNS_SH1],
  mandatoryFields: [...UNITMIX_TABLE_COLUMNS_SH1_MANDATORY],
  allFields: [...UNITMIX_TABLE_COLUMNS_SH1_ALL]
}

export const propertySearchDataToCompsMapping = {
  summaryData: [
    { key: 'name', value: 'name' },
    { key: 'city', value: 'city' },
    { key: 'propertyAddress', value: 'propertyAddress' },
    { key: 'units', value: 'units' },
    { key: 'yearBuilt', value: 'yearBuilt' },
    { key: 'yearRen', value: 'yearRen' },
    { key: 'occupancyAsOfDate', value: 'occupancyAsOfDate' },
    { key: 'rentableSf', value: 'rentableSf' },
    { key: 'avgSf', value: 'averageSf' },
    { key: 'avgMarketRentSf', value: 'avgMarketRentSf' },
    { key: 'avgRentSf', value: 'averageRentSf' },
    { key: 'date', value: 'date' },
    { key: 'notes', value: 'sourceNote' },
    { key: 'propertyType', value: 'propertyType' },
    { key: 'mostRecentSaleDate', value: 'mostRecentSaleDate' },
    { key: 'mostRecentSalePrice', value: 'mostRecentSalePrice' },
    { key: 'priceUnit', value: 'priceUnit' },
    { key: 'priceSf', value: 'priceSf' },
    { key: 'sfSellerAccountId', value: 'sfSellerAccountId' },
    { key: 'sfBuyerAccountId', value: 'sfBuyerAccountId' },
    { key: 'capRate', value: 'capRate' },
    { key: 'grossRentMultiplier', value: 'grossRentMultiplier' },
    { key: 'termsOfSale', value: 'Terms' },
    { key: 'state', value: 'state' },
    { key: 'beds', value: 'beds' },
    { key: 'mrPerBed', value: 'mrPerBed' },
    { key: 'erPerBed', value: 'erPerBed' },
    { key: 'propertyAddressLatitude', value: 'propertyAddressLatitude' },
    { key: 'propertyAddressLongitude', value: 'propertyAddressLongitude' }
  ],
  propertyData: [
    { key: 'propertyType', value: 'propertyType' },
    { key: 'name', value: 'propertyName' },
    { key: 'city', value: 'city' },
    { key: 'addressLine1', value: 'addressLine1' },
    { key: 'county', value: 'propertyPropertyCounty' },
    { key: 'state', value: 'state' },
    { key: 'zipCode', value: 'zipCode' },
    { key: 'propertyAddress', value: 'Distance' }, // propertyAddressLatitude, propertyAddressLongitude
    { key: 'yearBuilt', value: 'yearBuilt' },
    { key: 'yearRen', value: 'yearRenovated' },
    { key: 'type', value: 'omniViewPropertyType' },
    { key: 'subType', value: 'subType' },
    { key: 'occupancyAsOfDate', value: 'occupancy' },
    { key: 'rentComments', value: 'propertyRentComments' },
    { key: 'notes', value: 'propertyRentComments' },
    { key: 'averageRentUnit', value: 'averageRentPerUnit' },
    { key: 'capRate', value: 'propertyCapRate' },
    { key: 'priceUnit', value: 'propertyPricePerUnit' },
    { key: 'propertyAddressLatitude', value: 'propertyAddressLatitude' },
    { key: 'propertyAddressLongitude', value: 'propertyAddressLongitude' }
  ],
  fromComparableData: [
    { key: 'amenities', value: 'amenities' },
    { key: 'amenitiesWriteins', value: 'amenitiesWriteins' },
    // { key: 'occupancyAsOfDate', value: 'occupancy' },
    { key: 'date', value: 'date' },
    { key: 'sourceNote', value: 'bcmSourceNotes' }
  ],
  fromComparableDataLastRow: [
    { key: 'units', value: 'units' },
    { key: 'beds', value: 'beds' },
    { key: 'averageRentSf', value: 'mrPerSf' },
    { key: 'rentableSf', value: 'totalSize' },
    { key: 'averageSf', value: 'unitSize' },
    { key: 'avgRentSf', value: 'mrPerSf' },
    { key: 'avgMarketRentSf', value: 'unitMarketRent' },
    { key: 'mrPerBed', value: 'mrPerBed' },
    { key: 'erPerBed', value: 'mrPerBed' }
  ],
  fromOmniviewtransactionhistory: [
    { key: 'mostRecentSaleDate', value: 'saleDate' },
    { key: 'mostRecentSalePrice', value: 'salePrice' },
    { key: 'priceSf', value: 'pricePerSf' },
    { key: 'sfSellerAccountId', value: 'sellerGoldenName' }, // omniviewtransactionhistorysf SellerAccountId, sellerGoldenName
    { key: 'sfBuyerAccountId', value: 'buyerGoldenName' }, // omniviewtransactionhistory sfBuyerAccountId
    { key: 'grossRentMultiplier', value: 'grossRentMultiplier' }
  ],
  comparableData: [
    { key: 'date', value: 'date' },
    { key: 'occupancyAsOfDate', value: 'occupancy' },
    { key: 'source', value: 'source' },
    { key: 'unitType', value: 'unitType' },
    { key: 'units', value: 'units' },
    { key: 'unitSize', value: 'unitSize' },
    { key: 'totalSize', value: 'totalSize' },
    { key: 'unitMarketRent', value: 'unitMarketRent' },
    { key: 'unitEffectiveRent', value: 'unitEffectiveRent' },
    { key: 'mrPerSf', value: 'rentPerSft' },
    { key: 'erPerSf', value: 'effectiveRentPerSft' },
    { key: 'totalMr', value: 'totalRent' },
    { key: 'totalEr', value: 'totalEffectiveRent' },
    { key: 'comments', value: 'comments' },
    { key: 'beds', value: 'beds' },
    { key: 'mrPerBed', value: 'mrBed' },
    { key: 'erPerBed', value: 'mrBed' },
    { key: 'omniViewPropertyRentId', value: 'omniViewPropertyRentId' }
  ]
}
